import axios from "../api/apiConfig";

export type DashboardDateRange = {
  from_date?: string;
  to_date?: string;
};

const getDashboardSummary = async (
  client_id?: string,
  vendor_id?: string,
  range?: DashboardDateRange
) => {
  const response = await axios.get("/dashboard", {
    params: {
      client_id: client_id || undefined,
      vendor_id: vendor_id || undefined,
      from_date: range?.from_date || undefined,
      to_date: range?.to_date || undefined,
    },
  });
  return response.data;
};

const getDashboardDetail = async (
  type: string,
  filter: string | undefined,
  client_id?: string,
  vendor_id?: string,
  extraParams?: Record<string, string | undefined>,
  range?: DashboardDateRange
) => {
  const response = await axios.get("/dashboard/detail", {
    params: {
      type,
      filter: filter || undefined,
      client_id: client_id || undefined,
      vendor_id: vendor_id || undefined,
      from_date: range?.from_date || undefined,
      to_date: range?.to_date || undefined,
      ...extraParams,
    },
  });
  return response.data;
};

export { getDashboardSummary, getDashboardDetail };
